import { handleActions } from 'redux-actions'
import {
    TABLE_CHECK_IN,
    TABLE_ESCALATION,
    TABLE_IN_SHOP_SCAN,
    TABLE_REFINEMENT_PRODUCTION,
    TABLE_REFINEMENT_SET,
    TABLE_REFINEMENT_SHOP,
    TABLE_RETAINER,
    TABLE_RETAINER_REFINEMENT,
    TABLE_SET,
    TABLE_SHOP_SCAN,
    TABLE_TREATMENT,
    TABLE_IMPLANT_3DSCAN,
    TABLE_IMPLANT_PLAN,
    TABLE_IMPLANT_TREATMENT,
    TABLE_REFINEMENT_BOOKING,
    TABLE_END_OF_TREATMENT,
} from './type'
import { createInitialTableState, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    salesOrderList: [],
    fetching: false,
    error: null,

    ...createInitialTableState(TABLE_SET, 'salesorder_salesorder_set', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_CHECK_IN, 'salesorder_salesorder_check_in', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_IN_SHOP_SCAN, 'salesorder_salesorder_in_shop_scan', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_SHOP_SCAN, 'salesorder_salesorder_shop_scan', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_TREATMENT, 'salesorder_salesorder_treatment', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_END_OF_TREATMENT, 'salesorder_salesorder_end_of_treatment', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_REFINEMENT_PRODUCTION, 'salesorder_salesorder_refinement_production', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_REFINEMENT_SET, 'salesorder_salesorder_refinement_set', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_REFINEMENT_BOOKING, 'salesorder_salesorder_refinement_booking', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_REFINEMENT_SHOP, 'salesorder_salesorder_refinement_shop', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_RETAINER, 'salesorder_salesorder_retainer', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_RETAINER_REFINEMENT, 'salesorder_salesorder_retainer_refinement', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_ESCALATION, 'salesorder_salesorder_escalation', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_IMPLANT_3DSCAN, 'salesorder_salesorder_implant_3dscan', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_IMPLANT_PLAN, 'salesorder_salesorder_implant_plan', {
        'salesorder_salesorder.created': DESC,
    }),
    ...createInitialTableState(TABLE_IMPLANT_TREATMENT, 'salesorder_salesorder_implant_treatment', {
        'salesorder_salesorder.created': DESC,
    }),
}


export default handleActions({
    ...createReducerFunction(TABLE_SET),
    ...createReducerFunction(TABLE_CHECK_IN),
    ...createReducerFunction(TABLE_IN_SHOP_SCAN),
    ...createReducerFunction(TABLE_SHOP_SCAN),
    ...createReducerFunction(TABLE_TREATMENT),
    ...createReducerFunction(TABLE_END_OF_TREATMENT),
    ...createReducerFunction(TABLE_REFINEMENT_PRODUCTION),
    ...createReducerFunction(TABLE_REFINEMENT_SET),
    ...createReducerFunction(TABLE_REFINEMENT_SHOP),
    ...createReducerFunction(TABLE_REFINEMENT_BOOKING),
    ...createReducerFunction(TABLE_RETAINER),
    ...createReducerFunction(TABLE_RETAINER_REFINEMENT),
    ...createReducerFunction(TABLE_ESCALATION),
    ...createReducerFunction(TABLE_IMPLANT_3DSCAN),
    ...createReducerFunction(TABLE_IMPLANT_PLAN),
    ...createReducerFunction(TABLE_IMPLANT_TREATMENT),
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/search/reducer.js